<template>
<modal-base class="currencies-modal" @clickOverlay="cancelUserCurrencies">
  <div class="currencies-modal__body">
    <div class="currencies-modal__title">
      Customize Currencies for&nbsp;Overview
    </div>
    <icon-base class="currencies-modal__close" @click.native="cancelUserCurrencies" red>
      <icon-cross/>
    </icon-base>
    <search-control
      id="currenciesModal"
      class="currencies-modal__search-control"
      :excludedTickers="selectedTickersIds"
      placeholder="Currency name"
      @onResultClick="onSelectCurrency"
      @onEnterPress="onSelectCurrency"
    >
    </search-control>
    <div class="currencies-field">
      <div
        class="currencies-item"
        :title="item.name"
        v-for="(item, index) in selectedCurrencies"
        :key="item.id"
      >
        <currency-icon :currencyId="item.id" class="currencies-item__icon"/>
        <div class="currencies-item__ticker">{{item.name}}</div>
        <icon-base class="currencies-item__close" @click.native="removeCurrency(index)" red>
          <icon-cross/>
        </icon-base>
      </div>
    </div>
    <button-el left large @click="cancelUserCurrencies" class="cancel-btn">
      Cancel
      <icon-base slot="icon" black>
        <icon-arrow-min left />
      </icon-base>
    </button-el>
    <button-el left red large @click="saveUserCurrencies" :disabled="sendingInProgress" class="save-btn">
      Save
      <icon-base slot="icon" red>
        <icon-check/>
      </icon-base>
    </button-el>
    <round-btn small @click="cancelUserCurrencies" class="close-round-btn">
      <icon-base red>
        <icon-cross />
      </icon-base>
    </round-btn>
  </div>
</modal-base>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import ModalBase from 'Common/ModalBase';
import { IconCross, IconArrowMin, IconCheck } from 'Icons';

export default {
  data: () => ({
    selectedCurrencies: [],
    sendingInProgress: false,
  }),
  components: {
    IconCross,
    IconCheck,
    IconArrowMin,
    ModalBase,
  },
  computed: {
    ...mapState('userCurrencies', [
      'currenciesList',
    ]),
    ...mapState('userData', [
      'settings',
    ]),
    selectedTickersIds() {
      return this.selectedCurrencies.map(p => p.id);
    },
  },
  methods: {
    ...mapActions('userCurrencies', [
      'udpateUserCurrencies',
    ]),
    close() {
      this.$emit('close');
    },
    onSelectCurrency(row) {
      this.selectedCurrencies.push(row);
    },
    saveUserCurrencies() {
      this.sendingInProgress = true;
      this.$apiService.udpateUserCurrencies(this.selectedTickersIds).then(() => {
        this.close();
      }).catch(() => {
        this.sendingInProgress = false;
      });
    },
    cancelUserCurrencies() {
      this.selectedCurrencies = [];
      this.close();
    },
    removeCurrency(index) {
      this.selectedCurrencies.splice(index, 1);
    },
  },
  mounted() {
    this.selectedCurrencies = cloneDeep(this.settings.subscribedTickers);
  },
};
</script>

<style lang="scss" scoped>
  .currencies-modal {
    &__title {
      @include font(17px, $black-color1, 500);
      line-height: 23px;
    }
    &__close {
      cursor: pointer;
      position: absolute;
      right: 30px;
      top: 30px;
    }
    &__body {
      border-radius: 5px;
      margin: auto;
      background: $white-color2;
      position: relative;
      width: 720px;
      max-width: 100%;
      padding: 30px;
      z-index: 2;
    }
    &__search-control {
      margin-top: 18px;
      margin-bottom: 31px;
    }
  }
  $icon-w: 16px;
  $cross-w: 12px;
  .currencies-field {
    max-width: 660px;
    min-height: 110px;
    border-radius: 5px;
    margin-bottom: 49px;
    padding: 30px 30px 20px;
    @include customBorder(4px, 1px, 5px);
  }
  .currencies-item {
    padding: 0 19px;
    border-radius: 33px;
    background: $white-color2;
    display: inline-flex;
    align-items: center;
    height: 49px;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.07);
    z-index: 1;
    position: relative;
    margin-bottom: 10px;
    margin-right: 15px;
    max-width: 100%;
    &__icon {
      margin-right: 5px;
      width: $icon-w;
      height: 16px;
      margin-left: 1px;
    }
    &__ticker {
      margin-right: 19px;
      @include trimOverflowText(100%);
      @include font(13px, $black-color1, 500);
    }
    &__close {
      cursor: pointer;
    }
  }
  .cancel-btn {
    margin-right: 18px;
    padding: 11px 13px 10px 19px;
    max-width: 181px;
  }
  .save-btn {
    padding: 11px 10px 10px 17px;
    max-width: 179px;
  }
  .close-round-btn {
    display: none;
  }
  @include mobileStyles {
    .currencies-modal__close,
    .cancel-btn {
      display: none;
    }
    .close-round-btn {
      display: inline-flex;
      margin-left: 30px;
      vertical-align: middle;
    }
    .currencies-modal {
      &__body {
        padding: 30px $popup-side-margin 38px;
      }
      &__title {
        padding-left: $popup-side-margin;
      }
    }
    .save-btn {
      margin-left: $popup-side-margin;
    }
    .currencies-field {
      margin-bottom: 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/settings/CurrenciesModal.vue